const NEFFY_USE_STORAGE_KEY = "neffyUseReportedAt";

export const clearStoragePreservingNeffyUse = () => {
  const reportedAt = localStorage.getItem(NEFFY_USE_STORAGE_KEY);
  localStorage.clear();
  if (reportedAt) {
    localStorage.setItem(NEFFY_USE_STORAGE_KEY, reportedAt);
  }
};

const readReportedAt = () => {
  try {
    return JSON.parse(localStorage.getItem(NEFFY_USE_STORAGE_KEY) || "{}");
  } catch {
    return {};
  }
};

export const getNeffyUseReportedAt = (medicationId) => {
  const reportedAt = Number(readReportedAt()[medicationId]);
  return Number.isFinite(reportedAt) ? reportedAt : 0;
};

export const isNeffyUseActive = (medicationId, status) =>
  String(status || "").toLowerCase() === "used" ||
  Boolean(getNeffyUseReportedAt(medicationId));

export const markNeffyUseReported = (medicationId) => {
  if (!medicationId) return 0;

  const reportedAt = Date.now();
  const reportedAtByMedication = readReportedAt();
  reportedAtByMedication[medicationId] = reportedAt;
  localStorage.setItem(
    NEFFY_USE_STORAGE_KEY,
    JSON.stringify(reportedAtByMedication),
  );
  return reportedAt;
};
